import { useState } from "react";
import { ChromePicker } from "react-color";
import rgbHex from "rgb-hex";

import styles from "./ColorInput.module.scss";

type ColorInputProps = {
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
};

export const ColorInput = ({ value, onChange, onBlur }: ColorInputProps) => {
  const [showPicker, setShowPicker] = useState(false);

  const handleBackdropClick = () => {
    setShowPicker(false);
    onBlur();
  };

  return (
    <div className={styles.wrapper}>
      <button className={styles.button} onClick={() => setShowPicker(!showPicker)}>
        <span className={styles.color} style={{ backgroundColor: value }}></span>
      </button>
      {showPicker && (
        <>
          <div className={styles.backdrop} onClick={handleBackdropClick} aria-hidden="true" />
          <ChromePicker
            color={value}
            onChange={(color) => onChange(`#${rgbHex(color.rgb.r, color.rgb.g, color.rgb.b, color.rgb.a)}`)}
            className={styles.picker}
          />
        </>
      )}
    </div>
  );
};
